<template>
  <div class="index">
    <div class="content-left">
      <div class="titlelogo">
        <img src="@/assets/logo_khy.png" alt="" />
        <h3>医疗机构在线考核云平台</h3>
      </div>
    </div>
    <main>
      <div class="hader_title">
        <div class="title" v-for="(item, index) in titleArr" :key="index">
          <div :class="isActive == item.id ? 'blue' : ''">{{ item.id }}</div>
          <p>{{ item.name }}</p>
          <p v-if="item.id !== titleArr.length"></p>
        </div>
      </div>
      <div class="main_view">
        <div v-if="isActive == 1" class="view">
          <el-form
            :model="loginForm"
            :rules="rules"
            ref="ruleForm"
            label-width="180px"
            class="demo-ruleForm"
          >
            <el-form-item label="账号：" prop="user">
              <el-input
                v-model="loginForm.user"
                placeholder="请输入当前账号"
              ></el-input>
            </el-form-item>
            <el-form-item label="旧密码：" prop="oldPass">
              <el-input
                v-model="loginForm.oldPass"
                show-password
                placeholder="请输入当前账号密码"
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="password" class="new_pass">
              <el-input
                v-model="loginForm.password"
                show-password
                placeholder="请输入新密码"
                maxlength="20"
                @change="checkpassword"
              ></el-input>
              <div
                class="state_remind positioning"
                v-if="loginForm.password == ''"
              >
                <h5>密码长度为6-20位，需同时包含大小写字母和数字</h5>
              </div>
              <div
                class="pmgressbar positioning"
                :class="{
                  heightvalue: passwordlavel == 0,
                  middlevalue: passwordlavel == 1,
                  minvalue: passwordlavel == 2
                }"
                v-else
              >
                <span>密码强度：</span>
                <div></div>
                <div></div>
                <div></div>
                <span ref="textPawStyle">{{ textPaw }}</span>
              </div>
            </el-form-item>
            <el-form-item label="再次输入新密码：" prop="checkpass">
              <el-input
                v-model="loginForm.checkpass"
                show-password
                maxlength="20"
                placeholder="请再次输入新密码"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button @click="buttonType('ruleForm')" class="button"
            >下一步</el-button
          >
        </div>
        <div v-else-if="isActive == 2" class="view">
          <div class="success">
            <div class="suclog"></div>

            <h2>恭喜您成功修改了密码</h2>

            <h3>10秒后自动跳转到登录页，或您可以点击下方的完成立即前往登录</h3>
          </div>
          <el-button type="primary" class="forget_btn" @click="finishBtn()"
            >完成</el-button
          >
        </div>
      </div>
    </main>
    <div class="foot">
      Copyright 2005-2018 英腾教育科技股份有限公司 备案信息：桂ICP备09009842号
    </div>
  </div>
</template>

<script>
import { strongPass, ModifyPass2 } from "@/utils/validata";
import forget from "@/api/forgetpassword";
import md5 from "js-md5";
export default {
  name: "indexs",
  data() {
    return {
      passwordlavel: "", //密码校验登记
      textPaw: "",
      isActive: 1,
      titleArr: [
        {
          id: 1,
          name: "验证身份"
        },
        {
          id: 2,
          name: "完成"
        }
      ],
      loginForm: {
        user: "", // 账号
        oldPass: "", // 旧密码
        password: "", // 新密码
        checkpass: "" // 再次确定
      },
      timer: null, // 定时器名称
      rules: {
        user: [{ required: true, message: "请输入账号", trigger: "blur" }],
        oldPass: [
          { required: true, message: "请输入当前账号密码", trigger: "blur" }
        ],
        password: [
          { required: true, validator: strongPass(this), trigger: "blur" }
        ],
        checkpass: [
          { required: true, validator: ModifyPass2(this), trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    buttonType(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const obj = {
            guid: this.$route.query.guid,
            userID: this.$route.query.userID,
            newPwd: md5(this.loginForm.password), // 新密码
            oldPwd: md5(this.loginForm.oldPass) // 旧密码
          };
          const { data } = await forget.modifyPwd(obj);
          if (data.Status == 200) {
            this.isActive = 2; // 第二步
            this.timer = setTimeout(() => {
              this.finishBtn(); // 10秒后自动跳转登录页
            }, 10000);
          } else {
            this.$message.error(data.Data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    checkpassword() {
      let minreg = /^\d+$/; //纯数字
      let minreg2 = /^[A-Za-z]+$/; //纯字母
      let meddile = /^([0-9]+[a-zA-Z]+|[a-zA-Z]+[0-9]+)[0-9a-zA-Z]*$/; //字母加数字
      let meddile2 = /^(?![A-z0-9]+$)([A-z~@*()_]+$)(?![A-z0-9~@*()_]{8,})$/; //纯字母加特殊符号
      let meddile3 = /^(?![A-z0-9]+$)(?![A-z~@*()_]+$)([0-9~@*()_]+$)(?![A-z0-9~@*()_]{8,})$/; //纯数字和特殊符号
      let heightvalues = /^(?![A-z0-9]+$)(?![A-z~@*()_]+$)(?![0-9~@*()_]+$)([A-z0-9~@*.()_]{8,})$/; // 纯字母和数字和特殊符号
      if (minreg.test(this.loginForm.password)) {
        this.passwordlavel = 0; //纯数字
        console.log("纯数字");
        this.textPaw = "弱";
      }
      if (minreg2.test(this.loginForm.password)) {
        this.passwordlavel = 0; //纯字母
        console.log("纯字母");
        this.textPaw = "弱";
      }

      if (meddile.test(this.loginForm.password)) {
        this.passwordlavel = 1; //纯字母
        this.textPaw = "中";
        console.log("字母和数字");
      }
      if (meddile2.test(this.loginForm.password)) {
        this.passwordlavel = 1; //纯字母
        console.log("纯字母和特殊符号");
        this.textPaw = "中";
      }
      if (meddile3.test(this.loginForm.password)) {
        this.passwordlavel = 1; //纯字母
        console.log("纯数字和特殊符号");
        this.textPaw = "中";
      }
      if (heightvalues.test(this.loginForm.password)) {
        this.passwordlavel = 2; //纯字母
        console.log("字母和数字和特殊符号");
        this.textPaw = "高";
      }
    },
    // 跳到登录页
    finishBtn() {
      this.$router.push({ name: "login" });
    }
  },
  beforeDestroy() {
    if (this.timer) { 
      // 销毁定时器
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  created() {
    this.loginForm.user = this.$route.query.user;
  }
};
</script>

<style lang="scss" scoped>
.index {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-left {
    // flex-grow: 1;
    background-color: rgb(255, 255, 255);
    .titlelogo {
      margin-top: 20px;
      height: 100px;
      margin-left: 40px;
      display: flex;
      color: rgb(67, 66, 170);
      align-items: center;
      img {
        width: 100px;
        height: 100px;
      }
      h3 {
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 56px;
        color: #333333;
        margin-left: 30px;
      }
    }
  }
}
main {
  margin-top: 50px;
  .hader_title {
    width: 680px;
    margin: 0 auto;
    display: flex;
    align-content: center;
    .title {
      flex: 3;
      // border: 1px solid #000;
      display: flex;
      align-content: center;
      line-height: 60px;
      &:nth-child(2) {
        flex: 1;
      }
      > div {
        border-radius: 50%;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        color: rgba(0, 0, 0, 0.14901960784313725);
        font-weight: bold;
        font-size: 18px;
        border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
        margin-right: 10px;
      }
      p {
        &:nth-child(2) {
          font-size: 24px;
        }
        &:nth-child(3) {
          // width: 100%;
          width: 300px;
          border-bottom: 2px solid #e9e9e9;
          height: 32px;
          margin-left: 30px;
        }
      }
    }
  }
  .main_view {
    width: 800px;
    margin: 0 auto;
    .view {
      height: 440px;
      margin-top: 60px;
      background: rgba(236, 246, 255, 0.5);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .el-input {
        width: 440px;
      }
      .new_pass {
        margin-bottom: 40px !important;
        position: relative;
      }
      .positioning {
        position: absolute;
        right: 0;
        top: 40px;
      }
      ::v-deep .el-form-item {
        // margin-bottom: 20px ;
      }
      ::v-deep .el-form-item__label {
        font-size: 18px;
        font-weight: bold;
        text-align: left !important;
      }
    }
  }
}
.blue {
  color: rgb(255, 255, 255) !important;
  background-color: #1890ff;
  border: none !important;
}
.foot {
  width: 638px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  margin: 140px auto;
}
.button {
  background: #409eff;
  color: #fff;
  width: 300px;
  margin-top: 20px;
}
.heightvalue {
  > :nth-child(2) {
    background-color: red;
  }
}
.middlevalue {
  > :nth-child(2) {
    background-color: red;
  }
  > :nth-child(3) {
    background-color: yellow;
  }
}
.minvalue {
  > :nth-child(2) {
    background-color: red;
  }
  > :nth-child(3) {
    background-color: yellow;
  }
  > :nth-child(4) {
    background-color: rgb(0, 255, 85) !important;
  }
}
.input2 {
  width: 390px;
}

.forget_btn {
  width: 300px;
  margin: 70px 150px;
}
::v-deep .el-form-item__label {
  width: 174px !important;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  opacity: 1;
}
::v-deep .el-form-item__content {
  margin-left: 174px !important;
}

.el-form {
  margin-top: 34px;
  display: flex;
  flex-direction: column;
}

.red {
  background: #ff0000 !important;
}
.yellow {
  background: #ffdd8d !important;
}
.green {
  background: #01d801 !important;
}
.state_remind {
  height: 50px;
  // background-color: bisque;
  h5 {
    font-family: PingFang SC;
    font-weight: 400;
    color: #bbbbbb;
  }
}
.pmgressbar {
  height: 50px;
  // background-color: bisque;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  span:nth-child(1) {
    display: inline-block;
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-right: 4px;
  }
  span:nth-last-of-type(1) {
    margin-left: 8px;
  }
  div {
    width: 50px;
    height: 5px;
    background: #f1f1f1f1;
    opacity: 1;
    border-right: 1px solid #fff;
    &:nth-last-of-type(1) {
      width: 70px;
      //   background: red;
    }
  }
}
.success {
  display: flex;
  align-items: center;
  flex-direction: column;
  .suclog {
    width: 105px;
    height: 73px;
    background-image: url("../../assets/successlog.png");
  }
  h2 {
    width: 200px;
    height: 28px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 32px;
    color: #1890ff;
    margin-top: 20px;
  }
}
h3 {
  font-size: 16px;
  color: rgb(155, 155, 155);
  margin-top: 20px;
}
.forget_btn {
  width: 300px;
  margin: 50px 100px;
  letter-spacing: 10px;
  transform: translate(33px, -10px);
}
</style>
